<template>
	<div class="list-group border-radius-2 no-border">
		<WidgetHeader :link="`/tests`">{{ header }}</WidgetHeader>
		<CompetencyTestSessionItem
		v-for="result in items"
		:item="result"
		@swipeLeftItem="swipeLeftItem"
		@swipeRightItem="swipeRightItem"
		@contextMenuItem="contextMenuItem"
		:swipedLeftItem="swipedLeftItem"
		@removeItem="removeItem"
		:key="result.CompetencyTestSessionID"
		/>
		<div v-if="!items.length" class="list-group-item">
			{{ $t('nothing-here') }}
		</div>
	</div>
</template>

<script>
import WidgetHeader from "./WidgetHeader";
import CompetencyTestSessionItem from "src/components/CompetencyTestSessionItem";

export default {
	name: 'TestsWidget',
	props: ['list', 'limit', 'header'],
	components: {
		WidgetHeader,
		CompetencyTestSessionItem,
	},
	data: function () {
		return {
			items: [],
			swipedLeftItem: null
		}
	},
	mounted() {
		this.$cfetch(`${this.$settings.APIBaseURL}/competencytests/session/list`, {
			data: {
				marked: false,
				teacher: [{
					id: this.$UserSession.getValue('id')
				}],
				limit: this.limit
			},
			method: 'post'
		})
		.then(json => {
			if (json.status.toLowerCase() === "success") {
				this.items = json.results;
			}
		})
		.catch(error => {
			this.$log.error.call(this, error);
		});
	},
	methods: {
		swipeLeftItem(item) {
			this.swipedLeftItem = item;
		},
		swipeRightItem(item) {
			if(this.swipedLeftItem && item.CompetencyTestSessionID == this.swipedLeftItem.CompetencyTestSessionID) {
				this.swipedLeftItem = null;
			}
		},
		contextMenuItem(item) {
			if(this.swipedLeftItem && item.CompetencyTestSessionID == this.swipedLeftItem.CompetencyTestSessionID) {
				this.swipedLeftItem = null;
			} else {
				this.swipedLeftItem = item;
			}
		},
		removeItem(/*item*/) {
			this.getCompetencyTestSessions();
		}
	}
};
</script>
